import { render, staticRenderFns } from "./test.vue?vue&type=template&id=a23e8116&scoped=true&"
import script from "./test.vue?vue&type=script&lang=ts&"
export * from "./test.vue?vue&type=script&lang=ts&"
import style0 from "./test.vue?vue&type=style&index=0&id=a23e8116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23e8116",
  null
  
)

export default component.exports